// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icloud-ui-action-button-wrap .lsqm-icon-svg.icloud-ui-action-button-icon{color:var(--color-gray-9);font-size:16px}.icon-add{font-size:14px}.icon-create{margin-right:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
